
import {useEffect, useState} from 'react';

const defaultRotateEvery = 7500;

export function useRotate<T>(
	arr: T[],
	interval: number = defaultRotateEvery,
) {
	const [rotate, setRotate] = useState(arr);

	// Set up useEffect to update the rotation
	// on the supplied interval
	useEffect(() => {
		if (!rotate.length) {
			return;
		}

		const handle = setTimeout(() => {
			setRotate([...rotate.slice(1), rotate[0]]);
		}, interval);

		return () => {
			clearTimeout(handle);
		};
	}, [rotate]);

	// Don't return setter; keep that abstracted
	return rotate;
}
